module.exports = __webpack_public_path__ + "img/64_7.91d720c9.png";